import { useCallback } from 'react';
import { Stack } from '@optimus-web/core';
import { useAPI } from '@mews/framework';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { fetchTrendingArticles } from '../actions';
import { sortArticles } from '../utils';
import { KnowledgeArticleList } from './KnowledgeArticleList';

export const TrendingArticleList = () => {
    const dispatch = useCommanderThunkDispatch();
    const call = useCallback(async () => dispatch(fetchTrendingArticles()), [dispatch]);
    const { data, isLoading } = useAPI(call, { articles: [] });

    return (
        <Stack spacing="200" vertical>
            {data.articles ? (
                <KnowledgeArticleList articles={sortArticles(data.articles)} isLoading={isLoading} />
            ) : null}
        </Stack>
    );
};
